import {Component, inject} from '@angular/core';
import {ButtonDirective} from 'primeng/button';
import {PrimeTemplate} from 'primeng/api';
import {Toast} from 'primeng/toast';
import {AppUpdateService} from '../../services/update-sw.service';

@Component({
  selector: 'app-app-update-toast',
  imports: [
    ButtonDirective,
    PrimeTemplate,
    Toast
  ],
  templateUrl: './app-update-toast.html',
  styleUrl: './app-update-toast.scss',
  standalone: true
})
export class AppUpdateToast {
  updateService = inject(AppUpdateService);

  update() {
    this.updateService.updateApp();
  }
}
